import models from '../../data/models';

const mapStateToProps = state =>
  Object.keys(models).reduce(
    (acc, curr) => ({...acc, [curr]: state[curr]}),
    {},
  );

export default mapStateToProps;
